<script setup>
import {
    defineProps,
    nextTick,
    // defineEmits,
    onMounted,
    ref,
    watch,
    //  computed
} from 'vue';
import i18n from "@/i18n"
import { showMessage } from "@/utils/hooks/message"
// const emits = defineEmits(['search',])
import usetablePageNation from "@/utils/hooks/usetablePageNation" //分页hooks
import { getDashboardPerformance_comparison } from "@/service/apiList/dashboard"
import { dashbordChart1 } from "@/utils/chart"
import PreviewImg from "@/components/common/PreviewImg";
import myDailog from "../common/myDailog";
import { getProductTemplatePt } from "@/service/"
import { getLangValue, makeQrCode } from "@/utils/common"; //获取后端语言
// import { drawRadar } from "@/utils/chart.js"
const activeImageSrc = ref('')
const showPreviewImg = ref(false)
const props = defineProps({
    // hscodeList: {
    //     type: Array,
    //     required: true,
    //     default: () => []
    // },
    databaseList: {
        type: Array,
        required: true,
        default: () => []
    },
})
const myChartsRef = ref(null)
const chartRef = ref(null)
const tableInfo = ref([])
const hscodeList = ref([])
const type = ref("")
const visible = ref(false)
const colors = ['#F06548', '#405189', '#0AB39C', 'green', 'pink']
const pageSizeOption = [10, 20, 30, 40, 50]
const loading = ref(false)
const { total, currentPage, pageSize, pageOption } = usetablePageNation(getDataList)
const hscode = ref('')
const keyword = ref('')
const selectedTableData = ref([])
const lastId = ref('')
const public_type_list = ref([]);
const public_type = ref('')
const searchInfo = ref({})
// const index_standard_group = ref([])
// 获取公开类型
const getPublic = (type) => {
    let arr = public_type_list.value.filter(item => item.id === type)
    if (arr.length) {
        return arr[0].name
    }
    return ''
}
// 获取公开类型列表
const getProductTemplatePublicType = async () => {
    const resp = await getProductTemplatePt();
    if (resp.code == 0) {
        public_type_list.value = resp.payload
    }
}
const sort = (name) => {
    searchInfo.value.name = name
    searchInfo.value.type = searchInfo.value.type == 'asc' ? 'desc' : 'asc'
    getDataList()
}
const getDataList = async () => {
    // 获取table 数据
    loading.value = true
    // selectedTableData.value = []
    //获取数据
    let params = {
        page: currentPage.value - 1,
        limit: pageSize.value,
        // hscode_id: hscode.value != null && hscode.value != '' && hscode.value.length ? [...hscode.value].pop() : '',
        hscode_id: hscode.value,
        keyword: keyword.value.trim().replace('FBD', ''),
        category_id: 2, //感官舒适性
        product_template_name: type.value,
        public_type: public_type.value,
        order_by: searchInfo.value.type,
        sort_field: searchInfo.value.name,
    }
    // 产品性能
    const resp = await getDashboardPerformance_comparison(params);
    loading.value = false
    if (resp.code == 0) {
        if (resp.payload.data.length == 0) {
            showMessage('info', getLangValue('base.no_data'))
            total.value = 0
            tableInfo.value = []
            return;
        }
        tableInfo.value = resp.payload.data;
        tableInfo.value.forEach(async element => {
            // 设置二维码
            if (element.pid) {
                const reps = await makeQrCode({ type: 2, id: element.id })
                if (reps) {
                    element.qrcodeImgUrl = reps
                }
            }
        });
        if (tableInfo.value.length && currentPage.value == 1 && selectedTableData.value.length == 0) {
            tableInfo.value[0].checked = true  // 默认展示第一个
            changCheckBox(tableInfo.value[0].id) // 选中事件
        }
        total.value = resp.payload.total
        // setPages();
        // 如果已经选择了数据 需要回显
        if (selectedTableData.value.length) {
            for (const item in selectedTableData.value) {
                // 如果由当前数据 就需要选中
                const obj = tableInfo.value.find(table => table.id == selectedTableData.value[item].id)
                if (obj) {
                    obj.checked = true;
                }
            }
        }
    }
}

const search = () => {
    //搜索
    // emits('search', { hscode: hscode.value, keyword: keyword.value, })
    if (!hscode.value) {
        showMessage('danger', getLangValue('dashboard.fillDataMessage1'))
        return;
    }
    currentPage.value = 1;
    selectedTableData.value = []; //置空
    getDataList();
}

// const setPages = () => {
//     pageOption.value = [];
//     let numberOfPages = Math.ceil(total.value / pageSize.value);
//     for (let index = 1; index <= numberOfPages; index++) {
//         pageOption.value.push(index);
//     }
// }

const getMyData = (item, index) => {
    let arr = []
    item?.index_standard_statistics?.forEach(item1 => {
        item1?.index_standard_list?.forEach(item2 => {
            arr.push({ value: item2.value, no: index })
        })
    })
    return arr
}

const setCharts = () => {
    // 图表绘制
    // let xAxisData = [getLangValue('attribute.structure'), getLangValue('attribute.safety'), getLangValue('attribute.quality1')]
    let xAxisData = []
    selectedTableData.value[0].index_standard_statistics.map(item => {
        item.index_standard_list.map(item => {
            xAxisData.push(i18n.global.locale == 'en' ? item.index_standard?.name_en : item.index_standard?.name)
        })
    })
    let option = {
        legend: { show: false },
        color: colors,
        tooltip: {
            trigger: 'axis',
            formatter: function (params) {
                let res = params[0].name + '<br/>'
                params.forEach(item => {
                    res += item.value ? `NO.${item.data.no + 1} ` + item.seriesName + ': ' + item.value + '<br/>' : `NO.${item.data.no + 1} ` + item.seriesName + ': -<br/>';
                })
                return res
            }
        },
        xAxis: {
            type: 'category', data: xAxisData, axisLabel: {
                align: 'center', // 设置标签居中
                show: xAxisData.length < 5 ? true : false
            }
        },
        yAxis: {
            max: 1
        },
        grid: {
            top: '3%',
            left: '3%',
            right: '4%',
            bottom: '20%',
            containLabel: true
        },
        series: selectedTableData.value.map((item, index) => {
            return {
                name: item.pid,
                type: 'bar',
                data: getMyData(item, index),
                barMaxWidth: 30,
                color: colors[index]
            }
        })
    };
    // if (xAxisData.length > 5) {
    //     option.dataZoom = [{
    //         type: 'slider',
    //         realtime: true,
    //         start: 0,
    //         end: 40,  // 初始展示40%
    //         height: 4,
    //         fillerColor: "rgba(17, 100, 210, 0.42)", // 滚动条颜色
    //         borderColor: "rgba(17, 100, 210, 0.12)",
    //         handleSize: 0, // 两边手柄尺寸
    //         showDetail: false, // 拖拽时是否展示滚动条两侧的文字
    //         bottom: 55,
    //         // zoomLock:true, // 是否只平移不缩放
    //         // moveOnMouseMove:true, //鼠标移动能触发数据窗口平移
    //         // zoomOnMouseWheel :true, //鼠标移动能触发数据窗口缩放
    //     },
    //     {
    //         type: "inside",  // 支持内部鼠标滚动平移
    //         start: 0,
    //         end: 40,
    //         zoomOnMouseWheel: false,  // 关闭滚轮缩放
    //         moveOnMouseWheel: true, // 开启滚轮平移
    //         moveOnMouseMove: true  // 鼠标移动能触发数据窗口平移 
    //     }]
    // }
    nextTick(() => {
        dashbordChart1(chartRef.value, option)
    })

}

const changCheckBox = (id) => {
    lastId.value = id
    // 复选框状态改变
    // let arr = []
    // tableInfo.value.forEach((item, index) => {
    //     if (item.checked) {
    //         item.no = index
    //         arr.push(item)
    //     }
    // })
    const item = tableInfo.value.find(item => item.id == id)
    if (item.checked) {
        selectedTableData.value.push(item);
    } else {
        const index = selectedTableData.value.findIndex(item => item.id == id)
        if (index > -1) {
            selectedTableData.value.splice(index, 1)
        }
    }
    if (selectedTableData.value.length <= 3) {
        if (selectedTableData.value.length)
            setCharts();
    } else {
        //去掉最后一个id
        tableInfo.value.forEach(item => {
            if (item.id == id)
                item.checked = false
        })
        //去掉
        const index = selectedTableData.value.findIndex(item => item.id == id)
        if (index > -1) {
            selectedTableData.value.splice(index, 1)
        }
        showMessage('info', getLangValue('dashboard.selectedLength3'))
        return
    }

}

const showImageCode = (url) => {
    /**查看二维码大图 */
    activeImageSrc.value = url;
    if (activeImageSrc.value == "") {
        return;
    }
    showPreviewImg.value = true;
}

const remove = (key) => {
    let id = selectedTableData.value[key].id
    selectedTableData.value.splice(key, 1)
    tableInfo.value.forEach(item => {
        if (item.id == id)
            item.checked = false
    })
    changCheckBox(id)
}

const changeTemplate = () => {
    hscode.value = ''
    if (type.value.length) {
        // console.log(type.value);
        let arr = props.databaseList.filter(item => item.value === type.value[0] && item.children.filter(item1 => item1.value === type.value[1]).length)
        if (arr.length) {
            // 获取shcode
            let arr1 = arr[0].children.filter(item => item.value === type.value[1])
            if (arr1.length) {
                hscodeList.value = arr1[0].database_template_list.map(item => {
                    return {
                        id: item.hscode?.id,
                        title: item.hscode?.title,
                        title_en: item.hscode?.title_en,
                    }
                })
            }
        }
    } else {
        hscodeList.value = []
    }
}

// const drawRadarChart = (dom, item) => {
//     /**雷达图 指标 */
//     let list = index_standard_list.value[item].list
//     let indicatorList = list.map(item => {
//         return { text: item.name, max: 100 }
//     })
//     let valueList = list.map(item => item.value)
//     let option = {
//         tooltip: {
//             trigger: 'axis',
//             confine: true,
//             formatter: function (params) {
//                 let str = ``;
//                 for (const item in params.value) {
//                     str += `<div>
//                         <div style='min-width:100px; text-align:left; display:inline-block'>
//                             ${indicatorList[item].text}
//                         </div>
//                             :
//                          <div style='min-width:100px; text-align:left; display:inline-block'>${params.value[item]==null? '-': params.value[item]}</div>
//                     </div>`
//                 }
//                 return str
//             }
//         },
//         radar: [
//             {
//                 indicator: indicatorList,
//                 radius: 60
//             }
//         ],
//         series: [
//             {
//                 type: 'radar',
//                 tooltip: {
//                     trigger: 'item',
//                 },
//                 radarIndex: 0,
//                 areaStyle: {},
//                 data: [
//                     {
//                         name: 'Precipitation',
//                         value: valueList
//                     },
//                 ]
//             }
//         ]
//     };
//     // visible.value = true
//     nextTick(() => {
//         drawRadar(dom, option)
//     })

// }

// const getTotalValue = (row) => {
//     // 获取每行总的指标值
//     if (row.index_standard_statistics && row.index_standard_statistics.length) {
//         //筛选
//         let arr = row.index_standard_statistics.filter(item => typeof item.value === 'number').map(item => item.value)
//         // 累加
//         return arr.reduce((accumulator, currentValue) => accumulator + currentValue, 0);
//     }
//     return 0
// }

onMounted(() => {
    // getDataList();
    // drawRadarChart();
    getProductTemplatePublicType()
})

watch(pageSize, () => {
    currentPage.value = 1;
    getDataList();
})

watch(currentPage, () => {
    getDataList();
})

watch(selectedTableData, (val) => {
    if (val.length) {
        document.getElementById('my-table').style.height = 'calc(100% - 350px)'
    } else {
        document.getElementById('my-table').style.height = '100%'
    }
}, { deep: true })


</script>
<template>
    <div class="indexTable1 px-3 py-2 " style="height: calc(100% - 1rem) ">
        <div class="d-flex justify-content-between align-items-center">
            <div class="search d-flex align-items-center">
                <!-- <el-select @change="changeTemplate" v-model="type" filterable clearable
                    :placeholder="getLangValue('dashboard.dataBaseType')" style="width: 226px; height: 38px;">
                    <el-option v-for="item in databaseList" :key="item.value" :label="item.name" :value="item.name" />
                </el-select> -->
                <el-cascader style="width: 226px; height: 38px;" v-model="type" :options="props.databaseList"
                    :placeholder="getLangValue('dashboard.dataBaseType')"
                    :props="{ label: i18n.global.locale == 'en' ? 'label_en' : 'label', }" @change="changeTemplate" />
                <el-select v-model="hscode" filterable clearable class="mx-2" placeholder="HS Code"
                    style="width: 204px; height: 38px;">
                    <el-option v-for="item in hscodeList" :key="item.value"
                        :label="i18n.global.locale == 'en' ? item.title_en : item.title" :value="item.id" />
                </el-select>
                <div class="form-icon">
                    <input style="width: 236px;" clearable class="form-control form-control-icon" v-model="keyword"
                        required :placeholder="getLangValue('dashboard.input1')" />
                    <i class="ri-search-line"></i>
                </div>
                <el-select v-model="public_type" filterable clearable class="mx-2"
                    :placeholder="getLangValue('product-template.publicType')" style="width: 204px; height: 38px;">
                    <el-option v-for="item in public_type_list" :key="item.id" :label="item.name" :value="item.id" />
                </el-select>
            </div>
            <button type="button" class="btn btn-success" @click="search()" style="min-width: 93px;">
                {{ getLangValue("base.search") }}
            </button>
        </div>
        <div style="flex-direction: column; height: calc(100% - 40px);" v-loading="loading">
            <div class="my-table my-2" id="my-table">
                <!-- 表格信息 -->
                <div style="height:calc(100% - 60px - 1rem); overflow-y: auto;" class="my-scroll-bar">
                    <el-table :data="tableInfo" :border="parentBorder" :hover-row="false"
                        style="width: 100%; height: 100%;">
                        <template #empty></template>
                        <el-table-column type="expand">
                            <template #default="props">
                                <div class="px-4" style="background-color: #F3F6F9">
                                    <div class="d-flex" style="border-bottom: 1px solid white;">
                                        <div class="p-2" style="flex: 1; height: 40px; color: #212529;">{{
                                            getLangValue('hscode.group_type_name') }}</div>
                                        <div class="p-2" style="flex: 1; height: 40px; color: #212529;">{{
                                            getLangValue('dashboard.comfort.comfort_normalized_val') }}</div>
                                    </div>
                                    <template
                                        v-if="props.row.index_standard_statistics && props.row.index_standard_statistics.length">
                                        <div class="d-flex" v-for="(item, key) in props.row.index_standard_statistics"
                                            :key="key"
                                            style="border-bottom: 1px solid #E5E7ED; background-color: white;"
                                            :class="key == props.row.index_standard_statistics.length - 1 ? 'noBorder' : ''">
                                            <div class="p-2" style="flex: 1;">{{ i18n.global.locale == 'en' ?
                                                item.group_name_en : item.group_name }}</div>
                                            <div class="p-2" style="flex: 1;">{{ item.normalized_value || '-' }}</div>
                                        </div>
                                    </template>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="No." type="index" width="80" />
                        <el-table-column label="HS Code" prop="hscode_title">
                            <template #default="props">
                                {{ i18n.global.locale == 'en' ? props.row?.hscode?.title_en : props.row?.hscode?.title
                                }}
                            </template>
                        </el-table-column>
                        <el-table-column :label="getLangValue('product-management', 'code_pid_gtin')" prop="pid">
                            <template #default="props">
                                <img @click="showImageCode(props.row.qrcodeImgUrl)" class="cursor-pointer"
                                    :title="`FBD` + props.row.pid" :src="props.row['qrcodeImgUrl']"
                                    style="width: 48px;height: 48px;" />
                            </template>
                        </el-table-column>
                        <el-table-column :label="getLangValue('product-template.productName')" prop="name">
                            <template #header>
                                <div class="d-flex align-items-center"
                                    :style="{ height: '36px', 'max-width': '120px', 'word-break': 'keep-all', 'white-space': 'normal' }">
                                    {{ getLangValue('product-template.productName') }}
                                    <div class="sortable mx-2 cursor-pointer" :class="searchInfo.name == 'name' && searchInfo.type == 'desc' ? 'sortdesc' :
                                        searchInfo.name == 'name' && searchInfo.type == 'asc' ? 'sortasc' : ''"
                                        style="position: relative; width: 14px; height: 10px;" @click="sort('name')">
                                    </div>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column :label="getLangValue('product-template.publicType')" prop="public_type">
                            <template #default="props">
                                {{ props.row.public_type ? getPublic(props.row.public_type) : '' }}
                            </template>
                        </el-table-column>
                        <!-- <el-table-column :label="getLangValue('dashboard.comfort.tableHeader15')" prop="productName">
                            <template #default="props">
                                {{ props.row.total_value }}
                            </template>
                        </el-table-column> -->
                        <el-table-column :label="getLangValue('base.operation')" prop="productName">
                            <template #default="props">
                                <input @change="changCheckBox(props.row.id)" class="form-check-input mt-0"
                                    type="checkbox" v-model="props.row.checked"
                                    aria-label="Checkbox for following text input">
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <!-- 分页 -->
                <Pagination v-if="total" v-model:page="currentPage" v-model:perPage="pageSize" :pages="pageOption"
                    :prePageOption="pageSizeOption" :tab_info_length="total" class="me-5 my-3 my-pagination">
                </Pagination>
            </div>
            <div class="charts " style="position: relative;" v-if="selectedTableData.length">
                <div style="width: 100%; height: 100%;" ref="chartRef"></div>
                <div style="position: absolute; bottom: -15px;width: 100%; flex-wrap: wrap;  min-height: 60px;"
                    class="d-flex justify-content-center">
                    <div class="mx-3 d-flex align-items-center" v-for="(item, key) in selectedTableData" :key="key"
                        style="color: #878A99;font-size: 14px;">
                        <div style="width: 14px; height: 14px;" :style="{ backgroundColor: colors[key] }"></div>
                        <span class="mx-2">No.{{ key + 1 }} {{ item.pid }}</span>
                        <i class="ri-delete-bin-line cursor-pointer" style="color: #ED5E5E;" @click="remove(key)"></i>
                    </div>
                </div>
                <!-- 图表列表 -->
                <!-- <div v-for="(item, key) in index_standard_list" :key="key" style="display: inline-block; width: 30%; "
                    class="m-2">
                    <div :id="`index_standard_chart` + key" style="height: 200px; width: 100%;">
                    </div>
                    <div style="text-align: center;">{{ item.group_name }}</div>
                </div> -->
            </div>
        </div>
    </div>
    <PreviewImg v-model:showPreviewImg="showPreviewImg" :src="activeImageSrc" :myWidth="400" v-if="showPreviewImg">
    </PreviewImg>
    <!-- 弹框展示图表 -->
    <myDailog v-if="visible" v-model:visible="visible" :title="getLangValue('product-template.compositionStructure')">
        <div style="height: 100%; height: 500px;" ref="myChartsRef"></div>
    </myDailog>
</template>
<style scoped lang="scss">
.indexTable {
    .search {
        flex: 1;
        height: 38px;

        :deep(.el-input--suffix) {
            // width: 110px;
            height: 100%;
        }

        :deep(.el-select__wrapper) {
            background-color: #4a5056;
            height: 100%;
        }

        :deep(.el-select__placeholder.is-transparent) {
            color: #889AA5 !important;
        }

        :deep(.el-select__selected-item) {
            color: white;
        }

        :deep(.el-input__wrapper) {
            background-color: #4a5056;
        }

        :deep(.el-input__inner) {
            color: white;
        }

        .form-icon {
            display: inline-block;

            i {
                color: white
            }
        }

        .form-control {
            background-color: #4a5056;
            color: white;
            display: inline-block;
        }
    }

    .my-table {
        flex: 1; //way-2
        height: 100%; //way-2

        // max-height: 500px; // way-1
        table {
            color: white;
        }

        .el-table {
            color: white;
            background-color: unset;

            :deep(tr) {
                background-color: unset !important;
            }
        }

        :deep(.el-table__expand-icon) {
            color: white;
        }

        :deep(.el-table__expanded-cell, ) {
            background-color: unset;
        }

        :deep(.el-table__row, .el-table tr) {
            background-color: unset !important;

            &:hover {
                background-color: unset;
            }
        }

        :deep(.el-table tbody tr:hover td) {
            background-color: unset !important;
            ;
        }

        :deep(.el-table__inner-wrapper:before) {
            background-color: unset;
        }

        .my-pagination {
            color: white;

            :deep(.page_total) {
                color: white !important;
            }
        }

        .noBorder {
            border: unset !important;
            ;
        }
    }

    .charts {
        height: 350px;
    }
}

.indexTable1 {
    .search {
        flex: 1;
        height: 38px;

        :deep(.el-input--suffix) {
            // width: 110px;
            height: 100%;
        }

        :deep(.el-select__wrapper) {
            // background-color: #4a5056;
            height: 100%;
        }

        :deep(.el-select__placeholder.is-transparent) {
            font-size: 0.8125rem;
            color: #878a99 !important;
        }

        :deep(.el-cascader .el-input__inner) {
            &::placeholder {
                font-size: 0.8125rem;
                color: #878a99 !important;
            }
        }

        :deep(.el-select__selected-item.el-select__placeholder) {
            font-size: 0.8125rem;
            color: #212529;
        }

        // :deep(.el-input__wrapper) {
        //     // background-color: #4a5056;
        // }

        :deep(.el-input__inner) {
            font-size: 0.8125rem;
            color: #212529;
        }

        .form-icon {
            display: inline-block;

            i {
                color: #212529
            }
        }

        .form-control {
            // background-color: #4a5056;
            color: #212529;
            display: inline-block;
        }
    }

    .my-table {
        flex: 1; //way-2
        height: 100%; //way-2

        // max-height: 500px; // way-1
        table {
            color: #212529;
        }

        .el-table {
            color: #212529;
            background-color: unset;

            :deep(tr) {
                background-color: unset !important;
            }

            :deep(th.el-table__cell) {
                background-color: #F3F6F9;
            }

            :deep(thead) {

                color: #212529;
            }
        }

        :deep(.el-table__expand-icon) {
            color: #212529;
        }

        :deep(.el-table__expanded-cell, ) {
            background-color: unset;
        }

        :deep(.el-table__row, .el-table tr) {
            background-color: unset !important;

            &:hover {
                background-color: unset;
            }
        }

        :deep(.el-table tbody tr:hover td) {
            background-color: unset !important;
            ;
        }

        :deep(.el-table__inner-wrapper:before) {
            background-color: unset;
        }

        .my-pagination {
            color: #212529;

            :deep(.page_total) {
                color: #212529 !important;
            }
        }

        .noBorder {
            border: unset !important;
            ;
        }
    }

    .charts {
        height: 350px;
    }

    .sortable {
        &::after {
            content: "\f035d";
            position: absolute;
            right: .5rem;
            top: 0px;
            font-size: .8rem;
            font-family: "Material Design Icons";
            color: #bcbdbe;
        }

        &::before {
            content: "\f0360";
            position: absolute;
            right: .5rem;
            top: -8px;
            font-size: .8rem;
            font-family: "Material Design Icons";
            color: #bcbdbe;
        }
    }

    .sortdesc {
        &::after {
            color: black;
        }
    }

    .sortasc {
        &::before {
            color: black;
        }
    }
}
</style>